import { CLEAR_ALL, LOGOUT } from '../../store/Types';

export const ALL_PERMISOS = 'ALL_PERMISOS';
export const LOADING_ALL_PERMISOS = 'LOADING_ALL_PERMISOS';
export const ACTIVO_PERMISOS = 'ACTIVO_PERMISOS';
export const PARAMS_PERMISOS = 'PARAMS_PERMISOS';

const initialState = {
  all: [],
  loadingAll: false,
  activo: null,
  params: {},
  pagination: {
    currentPage: 1,
    itemCount: 1,
    itemsPerPage: 50,
    totalItems: 1,
    totalPages: 1,
  },
};

export const permisosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_PERMISOS:
      return {
        ...state,
        all: action.payload.data,
        pagination: action.payload?.meta ?? state.pagination,
      };
    case LOADING_ALL_PERMISOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case ACTIVO_PERMISOS:
      return {
        ...state,
        activo: action.payload,
      };
    case PARAMS_PERMISOS:
      return {
        ...state,
        params: action.payload,
      };
    case CLEAR_ALL:
      return {
        ...state,
        ...initialState,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
